import { DevTools } from 'jotai-devtools'

export const JotaiDevToolsProvider = () => {
  if (process.env.NODE_ENV === 'development') {
    return <DevTools />
  }

  return null
}
